import { defineEffect } from '../../../core/effect';
import { summonPanel } from '../fx/summonPanel';

/**
 * **特殊召喚成功（ステータスのパネル）**（Issue #573 v1。指示書 `../direction/spsummoning.md`）。
 * 通常召喚の成功（`summoned.js`）と同じ絵（`../fx/summonPanel.js`）。どのカードかは port が付ける `payload.summon`
 * （同じフェイズの直前の `spsummoning`。`editorPorts/duelEffects.js::duelPayloads`）。
 */
export default defineEffect(summonPanel({
  situation: 'spsummoned',
  role: 'effect',
  label: '特殊召喚成功（ステータスのパネル）',
  color: '#ffb21a',
}), 'spsummoned_effect.js');
